import React, { useState, useEffect } from 'react';
import { fetchStudentDashboardStats } from '../ApiHandler/studentFunctions';
import { fetchActiveLabs } from '../ApiHandler/labFunctions';
import './studentsDashboard.css';

const StudentsDashboard = () => {
    const [labs, setLabs] = useState([]);
    const [selectedLabId, setSelectedLabId] = useState('');
    const [stats, setStats] = useState({
        totalStudents: 0,
        totalKendras: 0,
        jeeAspirants: 0,
        neetAspirants: 0,
        cuetAspirants: 0,
        boardAspirants: 0,
        genderDistribution: [],
        schoolTypeDistribution: [],
        socialGroupDistribution: []
    });

    useEffect(() => {
        fetchActiveLabs(setLabs);
    }, []);

    useEffect(() => {
        fetchStudentDashboardStats(selectedLabId, setStats);
    }, [selectedLabId]);

    const Card = ({ iconClass, value, label, color }) => (
        <div className="stat-card" style={{ borderLeft: `4px solid ${color}` }}>
            <div className="icon-box" style={{ color: color, backgroundColor: `${color}15` }}>
                <i className={iconClass}></i>
            </div>
            <div className="stat-info">
                <h3>{value}</h3>
                <p>{label}</p>
            </div>
        </div>
    );

    const DistList = ({ title, data, field }) => (
        <div className="dist-box">
            <h4>{title}</h4>
            <ul>
                {data && data.length > 0 ? data.map((item, i) => (
                    <li key={i}>
                        <span>{item[field] || 'Unknown'}</span>
                        <strong>{item.count}</strong>
                    </li>
                )) : <li>No data available</li>}
            </ul>
        </div>
    );

    return (
        <div className="student-dashboard">
            <div className="header-row">
                <h2>{selectedLabId ? (labs.find(l => String(l.id) === String(selectedLabId))?.lab_name || '') + ' Dashboard' : 'UP Slate Student Dashboard'}</h2>
                <div className="lab-filter">
                    <select value={selectedLabId} onChange={e => setSelectedLabId(e.target.value)}>
                        <option value="">All Labs</option>
                        {labs.map(l => <option key={l.id} value={l.id}>{l.lab_name}</option>)}
                    </select>
                </div>
            </div>

            <div className="stats-grid">
                <Card iconClass="bx bx-user" value={stats.totalStudents} label="Total Students" color="#3b82f6" />
                <Card iconClass="bx bx-buildings" value={stats.totalKendras} label="Total Kendras" color="#10b981" />
                <Card iconClass="bx bx-book-open" value={stats.jeeAspirants} label="JEE Aspirants" color="#f59e0b" />
                <Card iconClass="bx bx-pulse" value={stats.neetAspirants} label="NEET Aspirants" color="#ef4444" />
                <Card iconClass="bx bx-bulb" value={stats.cuetAspirants} label="CUET Aspirants" color="#8b5cf6" />
                <Card iconClass="bx bx-pencil" value={stats.boardAspirants} label="Board Exam" color="#14b8a6" />
            </div>

            <div className="dist-grid">
                <DistList title="Gender Distribution" data={stats.genderDistribution} field="gender" />
                <DistList title="School Type Distribution" data={stats.schoolTypeDistribution} field="school_type" />
                <DistList title="Social Group Distribution" data={stats.socialGroupDistribution} field="social_group" />
            </div>

            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #6C5CE7', fontSize: '13px', color: '#555' }}>
                <i className='bx bx-shield-quarter' style={{ marginRight: '8px', color: '#6C5CE7' }}></i>
                <strong>Role-Based Access:</strong> To ensure data privacy, Teachers can only view records mapped to their assigned Lab or School, or records they have personally added. District Officers can view all records within their assigned District. Admin has global access.
            </div>
        </div>
    );
};

export default StudentsDashboard;
